import React from "react"
import { Stack, Typography } from "@mui/material"
import imgNov16_26 from "assets/images/events/Nov15_26.jpg"
import InfoCard from "components/controls/InfoCard"

const Events = () => {
  return (
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <InfoCard title="UPCOMING EVENTS">
        <Stack spacing={1}>
          <img
            alt="Heart Health Awareness"
            height="40%"
            src={imgNov16_26}
            width="100%"
          />
        </Stack>
        <Stack spacing={1} />
      </InfoCard>
      <InfoCard title="PAST EVENTS">
        <Stack spacing={1} />
      </InfoCard>
    </Stack>
  )
}

export default Events
